"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fail = exports.FAIL_STYLE_TYPE = void 0;
var _react = _interopRequireDefault(require("react"));
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
var _Message = require("./Message");
require("./Fail.scss");
let FAIL_STYLE_TYPE = exports.FAIL_STYLE_TYPE = /*#__PURE__*/function (FAIL_STYLE_TYPE) {
  FAIL_STYLE_TYPE["inline"] = "inline";
  FAIL_STYLE_TYPE["fill"] = "fill";
  FAIL_STYLE_TYPE["fullScreen"] = "fullScreen";
  FAIL_STYLE_TYPE["tableRow"] = "tableRow";
  return FAIL_STYLE_TYPE;
}({});
const Fail = _ref => {
  let {
    className,
    message,
    styleType = FAIL_STYLE_TYPE.inline
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-Fail', [`cds-Fail--${(0, _upperCase.upperCaseFirst)(styleType)}`], className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react.default.createElement(_Message.Message, null, message));
};
exports.Fail = Fail;
//# sourceMappingURL=Fail.js.map